/* eslint-disable react/no-array-index-key */

import { useMemo } from 'react';

import CurrencySign from 'components/price/CurrencySign.component';
import CONF from 'config/conf.singleton';
import { useGilt, useTranslation } from 'providers/GILT.provider';

import EmailClient from 'checkout/components/EmailClient';
import EmailClientNextAppointment from 'checkout/components/EmailClientNextAppointment';

const Email = ({ data, salonDetails = {}, clients }) => {
  const { t } = useTranslation();
  const { formatDate } = useGilt();

  const servicesWithDiscount = useMemo(() => {
    let total = 0;

    data.clients.forEach((client) => {
      if (client.services && client.products) {
        [...client.services, ...client.products].forEach((item) => {
          total += item.finalPrice;
        });
      }
    });

    return total;
  }, [data.clients]);

  const tip = useMemo(() => {
    if (data.tipType === 'absolute') {
      return data.tipAmount;
    }

    if (data.tipAmount) {
      return (data.tipAmount / 100) * servicesWithDiscount;
    }

    return 0;
  }, [data.tipAmount, data.tipType, servicesWithDiscount]);

  const date = formatDate(data.effective_date, { hideTime: true, hideWeekday: true });

  const emailClients = clients || data.clients;

  const imgSrc = salonDetails?.profile_image_url || null;

  const subTotal = useMemo(() => {
    let total = 0;

    data.clients.forEach((client) => {
      client.services?.forEach((s) => (total += s.finalPrice));
      client.products?.forEach((p) => (total += p.finalPrice));
    });

    // checking this is filtered for a stylist
    // we know this because clients don't have services
    if (data.clients.length && !data.clients[0].services) {
      total = data.total;
    }

    return total + parseFloat(tip);
  }, [data, tip]);

  const calcDeposit = useMemo(() => {
    let total = 0;

    if (data.deposits) {
      if (data.deposits.clientDeposits) {
        data.deposits.clientDeposits.forEach((d) => {
          total += d.amount;
        });
      } else {
        data.deposits.forEach((d) => {
          total += Math.abs(d.amount);
        });
      }
    }

    return total;
  }, [data.deposits]);

  const voucher = useMemo(() => {
    if (!data.vouchers_used) return 0;

    return -data.vouchers_used.reduce((sum, v) => sum + v.used_amount, 0);
  }, [data.vouchers_used]);

  const displayOnlineRebookingLinkHeader = (s1, s2, s3) => {
    if (salonDetails) {
      return (
        <th colSpan="2" style={s1}>
          <p style={s2}>{t('composite.email.linkDescription')}</p>
          <a href={`${CONF.bookingUrlRoot}${salonDetails.id}`} target="_blank" rel="noopener noreferrer" style={s3}>
            {CONF.onlineBookingUrl}
          </a>
        </th>
      );
    }

    return null;
  };

  const displayOnlineRebookingLink = (s45, link) => {
    if (salonDetails) {
      return (
        <p>
          <span style={s45}>{t('composite.email.linkDescription')}</span>
          <br />
          <a href={`${CONF.bookingUrlRoot}${salonDetails.id}`} target="_blank" rel="noopener noreferrer" style={link}>
            {CONF.onlineBookingUrl}
          </a>
        </p>
      );
    }
    return null;
  };

  const sImg = {
    borderRadius: '50%',
    mozBorderRadius: '50%',
    display: 'block',
    margin: ' 0 auto',
    border: '1px solid #f1f1f1',
    marginTop: '17px',
    height: '120px',
  };
  const link = {
    textAlign: 'center',
    fontSize: '12px',
    fontFamily: 'Open Sans,sans-serif',
    color: '#933cc1',
  };
  const table = {
    borderCollapse: 'collapse',
    width: '100%',
    maxWidth: '800px',
    margin: '0 auto',
    fontFamily: 'Open Sans,sans-serif',
  };
  const linkStyle1 = {
    backgroundColor: '#e5e5e5',
    textAlign: 'center',
    verticalAlign: 'middle',
    fontSize: '24px',
    fontFamily: 'Open Sans,sans-serif',
    fontWeight: 600,
  };
  const linkStyle2 = {
    textAlign: 'center',
    fontSize: '12px',
    fontFamily: 'Open Sans,sans-serif',
    marginBottom: '2px',
  };
  const linkStyle3 = { textAlign: 'center', fontSize: '12px', fontFamily: 'Open Sans,sans-serif', color: '#933cc1' };
  const s4 = {
    paddingLeft: '0',
    backgroundColor: '#e5e5e5',
    textAlign: 'left',
    verticalAlign: 'middle',
    borderBottom: '4px solid #933cc1',
    fontFamily: 'Open Sans,sans-serif',
  };
  const s6 = {
    backgroundColor: '#e5e5e5',
    textAlign: 'right',
    verticalAlign: 'middle',
    borderBottom: '4px solid #933cc1',
    fontFamily: 'Open Sans,sans-serif',
  };
  const s7 = {
    marginBottom: '0',
    fontFamily: 'Open Sans,sans-serif',
    fontSize: '14px',
    marginTop: '0',
    marginRight: '4px',
  };
  const s8 = {
    marginTop: '6px',
    fontFamily: 'Open Sans,sans-serif',
    fontSize: '11px',
    color: '#6b6d6f',
    marginBottom: '0',
  };
  const s9 = {
    backgroundColor: '#fff',
    textAlign: 'center',
    verticalAlign: 'middle',
    fontFamily: 'Open Sans,sans-serif',
    paddingTop: '0',
    paddingBottom: '0',
    paddingRight: '0',
    paddingLeft: '0',
  };
  const s10 = {
    backgroundColor: '#fff',
    borderBottom: '1px solid #e5e5e5',
    textAlign: 'center',
    verticalAlign: 'middle',
    fontSize: '24px',
    fontFamily: 'Open Sans,sans-serif',
    fontWeight: 600,
    paddingTop: '0',
    paddingBottom: '0',
    paddingRight: '0',
    paddingLeft: '0',
  };
  const title = {
    fontSize: '18px',
    color: '#6b6d6f',
    fontWeight: 100,
    marginBottom: '3px',
    marginTop: '10px',
    fontFamily: 'Open Sans,sans-serif',
  };
  const salonName = { fontSize: '24px', fontFamily: 'Open Sans,sans-serif', marginBottom: '12px', marginTop: '0' };
  const s13 = {
    whiteSpace: 'nowrap',
    backgroundColor: '#fff',
    textAlign: 'center',
    verticalAlign: 'middle',
    fontFamily: 'Open Sans,sans-serif',
    paddingTop: '0',
    paddingBottom: '0',
    paddingRight: '0',
    paddingLeft: '0',
  };

  const receiptDate = {
    marginLeft: ' 42px',
    marginTop: '0px',
    marginBottom: '0px',
    textAlign: 'left',
    fontSize: '14px',
    fontFamily: 'Open Sans,sans-serif',
  };
  const s15 = {
    backgroundColor: '#fff',
    textAlign: 'right',
    verticalAlign: 'middle',
    fontFamily: 'Open Sans,sans-serif',
  };
  const s16 = {
    textAlign: 'right',
    fontSize: '14px',
    fontFamily: 'Open Sans,sans-serif',
    color: '#6b6d6f',
    marginRight: '48px',
    marginTop: '0px',
    marginBottom: '0px',
  };
  const text = {
    marginTop: '4px',
    marginBottom: '0',
    marginRight: '48px',
    fontFamily: 'Open Sans,sans-serif',
  };

  const s36 = {
    marginTop: '4px',
    marginBottom: '6px',
    marginRight: '48px',
    fontFamily: 'Open Sans,sans-serif',
  };
  const priceLabel = {
    textAlign: 'left',
    fontSize: '14px',
    fontFamily: 'Open Sans,sans-serif',
    color: '#6b6d6f',
  };
  const price = {
    textAlign: 'right',
    fontSize: '14px',
    fontFamily: 'Open Sans,sans-serif',
    color: '#6b6d6f',
    marginLeft: '20px',
  };
  const empty = {
    marginBootom: '30px',
    backgroundColor: '#fff',
    textAlign: 'left',
    verticalAlign: 'middle',
    fontFamily: 'Open Sans,sans-serif',
  };
  const s39 = {
    marginTop: '4px',
    marginBootom: '4px',
    marginLeft: '42px',
    color: '#933cc1',
    fontSize: '14px',
    fontFamily: 'Open Sans,sans-serif',
  };
  const s40 = {
    borderBottom: '1px solid #e5e5e5',
    marginBootom: '30px',
    backgroundColor: '#fff',
    textAlign: 'right',
    verticalAlign: 'middle',
    fontFamily: 'Open Sans,sans-serif',
  };
  const s41 = {
    marginBootom: '0',
    marginTop: '0',
    fontSize: '14px',
    fontFamily: 'Open Sans,sans-serif',
    marginRight: '46px',
  };
  const s42 = {
    color: '#192340',
    fontSize: '18px',
    textAlign: 'right',
    fontWeight: 600,
    fontFamily: 'Open Sans,sans-serif',
  };
  const footerLabel = {
    color: '#933cc1',
    fontSize: '14px',
    fontFamily: 'Open Sans,sans-serif',
    textAlign: 'right',
    marginRight: '80px',
  };
  const s43 = {
    color: '#192340',
    fontSize: '18px',
    fontWeight: 600,
    fontFamily: 'Open Sans,sans-serif',
  };
  const s44 = {
    borderBottom: '1px solid #e5e5e5',
    marginBootom: '30px',
    backgroundColor: '#fff',
    textAlign: 'left',
    verticalAlign: 'middle',
    fontFamily: 'Open Sans,sans-serif',
  };
  const s45 = {
    textAlign: 'center',
    fontSize: '12px',
    fontFamily: 'Open Sans,sans-serif',
    marginBottom: '2px',
  };
  const s46 = {
    marginBootom: '30px',
    backgroundColor: '#fff',
    textAlign: 'right',
    verticalAlign: 'middle',
    fontFamily: 'Open Sans,sans-serif',
  };
  const normal = {
    backgroundColor: '#fff',
    textAlign: 'right',
    verticalAlign: 'middle',
    fontFamily: 'Open Sans,sans-serif',
  };
  const background = {
    backgroundColor: '#e5e5e5',
    fontFamily: 'Open Sans,sans-serif',
    position: 'relative',
    zIndex: 3000,
    minHeight: '980px',
    minWidth: '100%',
    width: '100%',
  };
  const vatNumber = { fontSize: '18px', fontFamily: 'Open Sans,sans-serif', marginBottom: '15px', marginTop: '15px' };

  return (
    <div style={background} id="receipt">
      <table className="body" style={table}>
        <tbody>
          <tr>
            <td className="center" style={{ textAlign: 'center', verticalAlign: 'top' }}>
              <center>
                <div>
                  <table cellPadding="10" cellSpacing="0" style={table}>
                    <thead>
                      <tr>{displayOnlineRebookingLinkHeader(linkStyle1, linkStyle2, linkStyle3)}</tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style={s4} />
                        <td style={s6}>
                          <h2 style={s7}>{t('composite.email.ref')}</h2>
                          {data?.id && <p style={s8}>{data.id.toString().padStart(6, '0')}</p>}
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="2" style={s9}>
                          {imgSrc && imgSrc.length > 400 ? <br /> : imgSrc && <img src={imgSrc} height="120" alt="Salon" style={sImg} />}
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="2" style={s10}>
                          <p style={title}>{t('composite.email.receiptFrom')}</p>
                          <h3 style={salonName}>{salonDetails.name}</h3>
                          {salonDetails.vat_number && <h2 style={vatNumber}>{t('composite.email.vatNumber', { number: salonDetails.vat_number })}</h2>}
                        </td>
                      </tr>
                      <tr>
                        <td style={s13}>
                          <h2 style={receiptDate}>{t('composite.email.receiptDate')}</h2>
                        </td>
                        <td style={s15}>
                          <p style={s16}>{date}</p>
                        </td>
                      </tr>
                      {emailClients.map((client, i) => (
                        <EmailClient tableStyle={table} client={client} key={i} />
                      ))}
                      <tr>
                        <td style={empty} />
                        <td style={normal}>
                          <p style={text}>
                            <span style={priceLabel}>{t('composite.email.tip')} </span>
                            <span style={price}>
                              <CurrencySign value={tip} />
                            </span>
                          </p>
                          <p style={s36}>
                            <span style={s42}>{t('composite.email.subtotal')} </span>
                            <span style={s43}>
                              <CurrencySign value={subTotal} />
                            </span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style={empty} />
                        <td style={s46}>
                          <p style={text}>
                            <span style={footerLabel}>{t('composite.email.paidWith')} </span>
                          </p>
                          {data.cardAmount > 0 ? (
                            <p style={text}>
                              <span style={priceLabel}>{t('composite.email.cardInStore')} </span>
                              <span style={price}>
                                <CurrencySign value={data.cardAmount} />
                              </span>
                            </p>
                          ) : null}
                          {data.onlineAmount > 0 ? (
                            <p style={text}>
                              <span style={priceLabel}>{t('composite.email.cardClient')} </span>
                              <span style={price}>
                                <CurrencySign value={data.onlineAmount} />
                              </span>
                            </p>
                          ) : null}
                          {data.partCash ? (
                            <p style={text}>
                              <span style={priceLabel}>{t('composite.email.cash')} </span>
                              <span style={price}>
                                <CurrencySign value={data.partCash} />
                              </span>
                            </p>
                          ) : null}
                          {calcDeposit > 0 && (
                            <p style={text}>
                              <span style={priceLabel}>{t('composite.email.depositRedeem')} </span>
                              <span style={price}>
                                <CurrencySign value={calcDeposit} />
                              </span>
                            </p>
                          )}
                          {data.otherAmount > 0 ? (
                            <p style={text}>
                              <span style={priceLabel}>{t('composite.email.other')} </span>
                              <span style={price}>
                                <CurrencySign value={data.otherAmount} />
                              </span>
                            </p>
                          ) : null}
                          {data.vouchers_used && data.vouchers_used.length > 0 && voucher ? (
                            <p style={text}>
                              <span style={priceLabel}>{t('composite.email.voucherRedeem')} </span>
                              <span style={price}>
                                <CurrencySign value={voucher} />
                              </span>
                            </p>
                          ) : null}
                        </td>
                      </tr>
                      <tr>
                        <td style={s44}>
                          <p style={s39} />
                        </td>
                        <td style={s40}>
                          <p style={s41} />
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  {emailClients.map((client, i) => (
                    <EmailClientNextAppointment tableStyle={table} client={client} key={i} />
                  ))}
                  {displayOnlineRebookingLink(s45, link)}
                </div>
              </center>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default Email;
